import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import styles from './App.module.scss';
import { RoutePaths } from './constants';
import { usePullToRefresh } from './hooks';
import { selectIsSignIn } from './store/auth/selectors';
import { authActions } from './store/auth/slice';
import { useDispatch } from './store/utils';
import { BlockWrapperWithSpinner, MainScreenWrapper, ProtectedRoute, Spinner } from 'components';
import {
  ActionsRequired,
  ForgotPassword,
  InvalidLinkPage,
  Login,
  Patient,
  SetUpPassword,
  Tasks,
  UserConsole,
} from 'pages';
import { selectAppIsLoading } from 'store/app/selectors';
import { useSelector } from 'store/utils';
import { UserRole } from 'types';
import { history } from 'utils';

const App = () => {
  const isSignedIn = useSelector(selectIsSignIn);
  const isAppLoading = useSelector(selectAppIsLoading);
  const dispatch = useDispatch();
  const [isCheckingIfSignin, setIsCheckingIfSignIn] = useState(true);

  history.navigate = useNavigate();
  history.location = useLocation();

  useEffect(() => {
    const checkingIfSignIn = async () => {
      await dispatch(authActions.checkIfUserIsSignedIn());
      setIsCheckingIfSignIn(false);
    };

    checkingIfSignIn();
  }, []);

  if (isCheckingIfSignin) {
    return (
      <div className={styles.spinnerContainer}>
        <Spinner isLoading={true} />
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/" element={isSignedIn ? <MainScreenWrapper /> : <Navigate replace to={RoutePaths.LOGIN} />}>
          <Route
            index
            element={
              <ProtectedRoute roles={[UserRole.ADMIN]} redirectTo={RoutePaths.PATIENTS}>
                <UserConsole />
              </ProtectedRoute>
            }
          />
          <Route path={RoutePaths.PATIENT_CASE} element={<Patient />} />
          <Route path={`${RoutePaths.TASKS}/:id`} element={<Tasks />} />
          <Route path={RoutePaths.DASHBOARD} element={<ActionsRequired />} />
        </Route>
        <Route path={RoutePaths.SET_UP_PASSWORD} element={<SetUpPassword />} />
        <Route
          path={RoutePaths.LOGIN}
          element={isSignedIn ? <Navigate replace to={RoutePaths.BASE_PATH} /> : <Login />}
        />
        <Route path={RoutePaths.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={RoutePaths.NOT_EXISTING_ROUTES} element={<InvalidLinkPage />} />
      </Routes>
      {isAppLoading && <BlockWrapperWithSpinner isLoading topLayer noBorderRadius />}
    </>
  );
};

export default App;
